import React from "react";
import {
  Box,
  Typography,
  Divider,
  useTheme,
  LinearProgress,
} from "@mui/material";
import { BatchAdvancedStats } from "../../../pages/playground/types";

// Helper function to format percentages
const formatPercentage = (value: number): string => {
  return value.toFixed(1) + "%";
};

// Component to display translation metrics and word averages
const MetricsContent: React.FC<{
  translationMetrics: BatchAdvancedStats["translation_metrics"];
  averageWordsPerSku: number;
}> = ({ translationMetrics, averageWordsPerSku }) => {
  const theme = useTheme();

  if (!translationMetrics) {
    return null;
  }

  return (
    <Box>
      {/* Translation Metrics Section */}
      {translationMetrics.languages.length > 0 && (
        <Box sx={{ p: 2, mb: 3 }}>
          <Typography variant="subtitle1" gutterBottom>
            Word Reuse
          </Typography>

          <Box display="flex" alignItems="center" mb={1}>
            <Box flex={1} mr={2}>
              <LinearProgress
                variant="determinate"
                value={translationMetrics.word_reuse_percentage}
                sx={{
                  height: 10,
                  borderRadius: 5,
                  backgroundColor: theme.palette.grey[200],
                  "& .MuiLinearProgress-bar": {
                    borderRadius: 5,
                    backgroundColor:
                      translationMetrics.word_reuse_percentage > 80
                        ? theme.palette.success.main
                        : translationMetrics.word_reuse_percentage > 40
                        ? theme.palette.warning.main
                        : theme.palette.error.main,
                  },
                }}
              />
            </Box>
            <Typography variant="body2" color="textSecondary">
              {formatPercentage(translationMetrics.word_reuse_percentage)}
            </Typography>
          </Box>

          {/* <Box mt={2}>
            <Typography variant="subtitle1" gutterBottom>
              Languages to translate
            </Typography>

            <Box display="flex" flexWrap="wrap" gap={1}>
              {translationMetrics.languages.map((lang: string) => {
                const langMetrics = translationMetrics.by_language[lang];

                const translatedPercentage =
                  (langMetrics.words_to_translate /
                    translationMetrics.total_words) *
                  100;

                return (
                  <Chip
                    key={lang}
                    label={
                      <>
                        {lang.toUpperCase()}: {langMetrics.words_to_translate}/
                        {translationMetrics.total_words} (
                        {formatPercentage(translatedPercentage)})
                      </>
                    }
                    size="small"
                    color={
                      translatedPercentage > 80
                        ? "success"
                        : translatedPercentage > 40
                        ? "warning"
                        : "error"
                    }
                    sx={{ mr: 0.5 }}
                  />
                );
              })}
            </Box>
          </Box> */}
        </Box>
      )}

      {/* Word Averages Section */}
      <Box sx={{ p: 2, mb: 3 }}>
        {/* <Typography variant="subtitle1" gutterBottom>
          Average Word Count
        </Typography> */}

        <Box
          display="flex"
          flexWrap="nowrap"
          alignItems="center"
          justifyContent="space-between"
        >
          {/* Total words display */}
          <Box flex={1} textAlign="center">
            <Typography variant="body2" color="text.secondary">
              Total Words
            </Typography>
            <Typography
              variant="h6"
              color="primary.main"
              sx={{ fontWeight: 600 }}
            >
              {translationMetrics.total_words}
            </Typography>
          </Box>

          <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

          <Box flex={1} textAlign="center">
            <Typography variant="body2" color="text.secondary">
              Average Words per SKU
            </Typography>
            <Typography variant="h6" color="secondary.main">
              {averageWordsPerSku.toFixed(1)}
              <Typography component="span" variant="caption" sx={{ ml: 0.5 }}>
                words/SKU
              </Typography>
            </Typography>
          </Box>

          {/* <Divider orientation="vertical" flexItem sx={{ mx: 1 }} /> */}

          {/* Average word counts by phrase type */}
          {/* {Object.entries(averages)
            .filter(([, count]) => count > 0)
            .map(([entryType, count]: [string, number], index, array) => (
              <React.Fragment key={entryType}>
                <Box flex={1} textAlign="center">
                  <Typography variant="body2" color="text.secondary">
                    {
                      BrandBatchSettingsDescriptionLabel[
                        entryType as BrandBatchSettingsDescriptionTypes
                      ]
                    }
                  </Typography>
                  <Typography variant="h6" color="secondary.main">
                    {count.toFixed(1)}
                    <Typography
                      component="span"
                      variant="caption"
                      sx={{ ml: 0.5 }}
                    >
                      words
                    </Typography>
                  </Typography>
                </Box>
                {index < array.length - 1 && (
                  <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                )}
              </React.Fragment>
            ))} */}
        </Box>
      </Box>
    </Box>
  );
};

// Main component that receives the BatchAdvancedStats
export const AdvancedStatsBox: React.FC<{ stats: BatchAdvancedStats }> = ({
  stats,
}) => {
  if (!stats) {
    return null;
  }

  return (
    <Box>
      <MetricsContent
        translationMetrics={stats.translation_metrics}
        averageWordsPerSku={stats.average_words_per_job}
        // averages={stats.average_words_by_type}
      />
    </Box>
  );
};

export default AdvancedStatsBox;
